import { RunnerActor, ShoppingState } from '@/state/RunnerStateMachine'
import { CollectibleEntity, CollectibleType } from '@/webgl/runner/entities/CollectibleEntity'

export enum ShoppingMode {
  Shop = 0,
  Balance = 1,
}

export default class ShoppingEntity {
  actor: RunnerActor
  state: ShoppingState = {
    walletValue: 43.5,
    cart: [],
    cartValue: 0,
    freezeActive: false,
    mode: ShoppingMode.Shop,
  }

  setActor(actor: RunnerActor) {
    this.actor = actor
  }

  notify(values: Partial<ShoppingState>) {
    this.actor?.send({ type: 'SHOPPING_STATE', value: values })
  }

  sync() {
    this.notify(this.state)
  }

  addToCart(collectible: CollectibleEntity) {
    if (collectible.data.type !== CollectibleType.Standard) return

    this.state.cart.push(collectible)
    this.state.cartValue += collectible.data.prices[collectible.priceID]

    this.sync()
  }

  removeFromCart(collectible: CollectibleEntity): boolean {
    const idx = this.state.cart.findIndex((c) => c.uuid === collectible.uuid)
    if (idx >= 0) {
      this.state.cart.splice(idx, 1)
      this.state.cartValue -= collectible.data.prices[collectible.priceID]
    }

    this.sync()

    return idx >= 0
  }

  setMode(mode: ShoppingMode) {
    this.state.mode = mode
    this.sync()
  }

  setWallet(value: number) {
    this.state.walletValue = value
    this.sync()
  }

  setFreeze(active: boolean) {
    this.state.freezeActive = active
    this.sync()
  }
}
